// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyDHwiMXCvO2KyV3FF63izZ3zM7WhcrUfxw",
    authDomain: "miclaroapp-9af23.firebaseapp.com",
    databaseURL: "https://miclaroapp-9af23.firebaseio.com",
    projectId: "miclaroapp-9af23",
    storageBucket: "miclaroapp-9af23.appspot.com",
    messagingSenderId: "13982630197",
    appId: "1:13982630197:web:f840ff74e1891601130c7c",
    measurementId: "G-PX48LH4PXN"
  },
  version: '2.19',
  deploymentAssetsPath:''
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
